import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=02996c53&scoped=true&lang=pug"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=02996c53&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02996c53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02996c53')) {
      api.createRecord('02996c53', component.options)
    } else {
      api.reload('02996c53', component.options)
    }
    module.hot.accept("./NewsPage.vue?vue&type=template&id=02996c53&scoped=true&lang=pug", function () {
      api.rerender('02996c53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/NewsPage.vue"
export default component.exports